import { Octicons } from '@expo/vector-icons';
import { SizableText, styled, XStack } from 'tamagui';

const ChipsContainer = styled(XStack, {
  alignItems: 'center',
  borderWidth: 1,
  borderRadius: '$5',
  paddingVertical: '$1',
  paddingHorizontal: '$2',
  gap: '$1',
});

interface ChipsProps {
  text: string;
  color: string;
}
export default function Chip({ text, color }: ChipsProps): React.ReactNode {
  return (
    <ChipsContainer>
      <Octicons name="dot-fill" size={16} color={color} />
      <SizableText fontFamily="$bold" size="$2">
        {text}
      </SizableText>
    </ChipsContainer>
  );
}
